import React, {useEffect, useRef, useState} from "react";
import {AmountDivideByHundred} from "../../../helper";
import {eventsPageSplitUpApi} from "../../../api";
import { Button, Input } from "antd";
import {SpError} from "../../../widgetDesign";
import SimpleReactValidator from "simple-react-validator";
import {isValidPhoneNumber} from "libphonenumber-js";
import brand from "../../../assets/imgs/brand.svg";

type Props = {
    eventDetails : Object,
    orderItems : Array<Object>,
    setPayload: Function,
    setPayNow: Function,
    payNow: Boolean,
    setErrorMessage: Function,
}

const ProductReview = (props: Props) => {
    const {
        eventDetails,
        orderItems,
        setPayload,
        setPayNow,
        payNow,
        setErrorMessage,
    } = props;

    const env = process.env;
    const [customInfoValues, setCustomInfoValues] = useState(
        eventDetails?.eventPageCustomInfos?.map((customInfo) => ({
            ...customInfo,
            value: customInfo.value || "",
        }))
    );

    const [promoCode, setPromoCode] = useState('');
    const [promoCodeValue, setPromoCodeValue] = useState('');
    const [message, setMessage] = useState('');

    const [subtotal, setSubtotal] = useState(0.00);
    const [orderDiscount, setOrderDiscount] = useState(0.00);
    const [serviceCharge, setServiceCharge] = useState(0.00);
    const [serviceFeePercentage, setServiceFeePercentage] = useState(0.00);
    const [taxes, setTaxes] = useState(0.00);
    const [tipAmount, setTipAmount] = useState(0.00);
    const [total, setTotal] = useState(0.00);

    const [tip, setTip] = useState(null);
    const [tipType, setTipType] = useState('AMOUNT');
    const [customTip, setCustomTip] = useState(false);
    const simpleValidator = useRef(new SimpleReactValidator({
        validators: {
            phoneNumValidation: {
                message: 'The phone number is invalid',
                rule: (val, param) => (isValidPhoneNumber(param[0])),
            },
            checkLowerCase: {
                message: 'Email address must not contain uppercase letters.',
                rule: (val) => val === val.toLowerCase(),
            },
        },
    }));

    const calculateOrder = async (tip, tipType, customTip, promoCode) => {
        if (eventDetails) {
            const payload = {
                eventPageGid: eventDetails.gid,
                promoCode: promoCode ? promoCode : null,
                tip: tip ? ( customTip ? tip.replace(/,/g,'').replace('.', '') : tip) : null,
                tipType,
                eventPageOrderLineItems: orderItems.flatMap(item => item.lineItems),
                eventPageOrderDiscounts: eventDetails.coupon ? [
                    {
                        discountGid: eventDetails.coupon.gid,
                        stackable: eventDetails.discountStackable,
                        type: 'COUPON',
                        amountOff: eventDetails.coupon.amountOff ? eventDetails.coupon.amountOff * -1 : eventDetails.coupon.amountOff,
                        percentageOff: eventDetails.coupon.percentageOff,
                    }
                ] : [],
            };

            const value = await eventsPageSplitUpApi(payload);

            if (value && value) {
                setSubtotal(value.subTotal ? AmountDivideByHundred(value.subTotal) : 0);
                setOrderDiscount(value.orderDiscount ? AmountDivideByHundred(value.orderDiscount * -1) : 0);
                setServiceCharge(value.serviceFee ? AmountDivideByHundred(value.serviceFee) : 0);
                setServiceFeePercentage(value.serviceFeePercentage ? AmountDivideByHundred(value.serviceFeePercentage) : 0);
                setTaxes(value.tax ? AmountDivideByHundred(value.tax) : 0);
                setTipAmount(value.tipAmount ? value.tipAmount : 0);
                setTotal(value.netPayable ? AmountDivideByHundred(value.netPayable) : 0);
                setMessage(value.message ? value.message : '');
            }
        }
    };

    useEffect(() => {
        calculateOrder();
    }, [orderItems]);

    useEffect(() => {
        if(!promoCodeValue) {
            setMessage('')
            calculateOrder(tip, tipType, customTip, null)
        }
    }, [promoCodeValue]);

    useEffect(() => {
        if(payNow && total > 0) {
            const formValid = simpleValidator.current.allValid();
            if (!formValid) {
                simpleValidator.current.showMessages();
                const list = [...customInfoValues]
                setCustomInfoValues(list);
                setPayNow(false);
                return;
            }
            const holdToken = sessionStorage.getItem('seatsio') ? JSON.parse(sessionStorage.getItem('seatsio')).holdToken : null;
            const normalize = (value) => (value ? value : []);
            const groupedLineItems = [];

            orderItems.flatMap(item => item.lineItems).forEach(lineItem => {
                debugger;
                const existingIndex = groupedLineItems.findIndex(existingItem =>
                    existingItem.customItemGid === lineItem.customItemGid
                    && existingItem.itemGid === lineItem.itemGid
                    && JSON.stringify(normalize(existingItem.lineItemModifiers)) === JSON.stringify(normalize(lineItem.lineItemModifiers))
                    && JSON.stringify(normalize(existingItem.lineItemItems)) === JSON.stringify(normalize(lineItem.lineItemItems))
                    && JSON.stringify(normalize(existingItem.lineItemDiscounts)) === JSON.stringify(normalize(lineItem.lineItemDiscounts))
                );

                if (existingIndex !== -1) {
                    groupedLineItems[existingIndex].quantity = groupedLineItems[existingIndex].quantity + lineItem.quantity;
                } else {
                    groupedLineItems.push({
                        ...lineItem,
                        lineItemDiscounts: [],
                    });
                }
            });

            setPayload({
                eventPageGid: eventDetails.gid,
                promoCode: promoCode && message && message === 'Promo-Code applied' ? promoCode : null,
                totalTip: tipAmount,
                holdToken,
                eventPageOrderLineItems: groupedLineItems,
                eventPageOrderLabels: customInfoValues
                    .filter(customInfo => customInfo.value)
                    .map(customInfo => ({ label: customInfo.inputFieldLabel, value: customInfo.value })),
                eventPageOrderLink: {redirectUri: (env.REACT_APP_ENV === "Production" ? "https://dashboard.swirepay.com" : "https://staging.swirepay.com") + "/event-page-receipts"},
                orderMode: "ONLINE",
            });
        } else {
            if(payNow && total === 0) {
                setErrorMessage("Total can't be zero...")
            }
            setPayNow(false);
        }
    }, [payNow]);

    const handleInputChange = (index, newValue) => {
        const updatedCustomInfos = [...customInfoValues];
        updatedCustomInfos[index].value = newValue; // Update the value at the given index
        setCustomInfoValues(updatedCustomInfos); // Update the state
    };


    const handleApplyPromo = () => {
        setPromoCode(promoCodeValue);
        calculateOrder(tip, tipType, customTip, promoCodeValue);
    }

    return (
        <div className="product-screen">
            {/* Header */}
            <h2 style={{ textAlign: "center", marginBottom: "20px", fontWeight: "bold" }}>
                Review & Proceed
            </h2>

            {/* Product Details */}
            {orderItems.map((item, index) => {
                return (item.lineItems && item.lineItems.length > 0) ? (
                <div key={index} style={{marginBottom: "20px"}}>
                    <h3 style={{marginBottom: "10px", fontWeight: "bold", color: '#676767'}}>{item.name}</h3>
                    {item.lineItems.map((lineItem, lineIndex) => {
                        return (
                            <div key={lineIndex}
                                 className="d-flex align-items-center justify-content-between"
                                 style={{ marginLeft: "10px", padding: "10px 0" }}
                            >
                                <div style={{textAlign: "left", width: '60%'}}>
                                    <h4 style={{margin: "0"}}>{lineItem.name}</h4>
                                    {lineItem.seats?.length > 0 && (<p className="additional-info" style={{ margin: "5px 0" }}>Seats: [{lineItem.seats.join(", ")}]</p>)}
                                    <p style={{ margin: "5px 0", color: "#555"}}>
                                        ${lineItem.price ? AmountDivideByHundred(lineItem.price) : "0.00"}
                                        {lineItem.lineItemDiscounts?.length > 0 && (
                                            <span className="sc-fbJfA uhGua discount-badge">
                                                  {lineItem.lineItemDiscounts[0].percentageOff
                                                      ? `${lineItem.lineItemDiscounts[0].percentageOff}%`
                                                      : `${lineItem.price > lineItem.lineItemDiscounts[0].amountOff ? "$ " : "100% upto $ "}${AmountDivideByHundred(lineItem.lineItemDiscounts[0].amountOff * -1)}`
                                                  } Off
                                              </span>
                                        )}
                                    </p>
                                    {lineItem.lineItemModifiers && lineItem.lineItemModifiers.length > 0 && (
                                        <>
                                            <p className="additional-info">Modifiers:</p>
                                            {lineItem.lineItemModifiers.map((lineItemModifier, lineIndex) => (
                                                <p
                                                    key={lineIndex}
                                                    style={{margin: "7.5px 20px", fontSize: "14px", color: "#555"}}
                                                >
                                                    {lineItemModifier.name} ($
                                                    {lineItemModifier.price ? AmountDivideByHundred(lineItemModifier.price) : "0.00"} x
                                                    {lineItemModifier.quantity})
                                                </p>
                                            ))}
                                        </>
                                    )}
                                    {lineItem.lineItemItems && lineItem.lineItemItems.length > 0 && (
                                        <>
                                            <p className="additional-info">
                                                Items:
                                            </p>
                                            {lineItem.lineItemItems.map((lineItemItem, lineIndex) => (
                                                <div key={lineIndex}>
                                                    <p
                                                        style={{ margin: "7.5px 20px", fontSize: "14px", color: "#555" }}
                                                    >
                                                        {lineItemItem.name}
                                                         ({lineItemItem.lineItemModifiers && lineItemItem.lineItemModifiers.length > 0
                                                            ? `($ ${lineItemItem.price ? AmountDivideByHundred(lineItemItem.price) : "0.00"} + (M - $ ${AmountDivideByHundred(lineItemItem.lineItemModifiers.reduce(
                                                                (sum, modifier) => sum + (modifier.quantity * modifier.price || 0), 0
                                                            ))}))`
                                                            : `$ ${lineItemItem.price ? AmountDivideByHundred(lineItemItem.price) : "0.00"}`
                                                        } x {lineItemItem.quantity})
                                                        {lineItemItem.lineItemDiscounts?.length > 0 && (
                                                        <span className="sc-fbJfA uhGua discount-badge">
                                                            {lineItemItem.lineItemDiscounts[0].percentageOff
                                                              ? `${lineItemItem.lineItemDiscounts[0].percentageOff}%`
                                                              : `${lineItemItem.price > (lineItemItem.lineItemDiscounts[0].amountOff * -1) ? "$ " : "100% upto $ "}${AmountDivideByHundred(lineItemItem.lineItemDiscounts[0].amountOff * -1)}`
                                                            } Off
                                                        </span>
                                                        )}
                                                    </p>

                                                    {lineItemItem.lineItemModifiers && lineItemItem.lineItemModifiers.length > 0 && (
                                                        <>
                                                            <p className="additional-info" style={{ margin: "7.5px 20px" }}>
                                                                Modifiers(M):
                                                            </p>
                                                            {lineItemItem.lineItemModifiers.map((lineItemModifier, lineItemIndex) => (
                                                                <p
                                                                    key={`${lineIndex}-${lineItemIndex}`}
                                                                    style={{ margin: "7.5px 40px", fontSize: "14px", color: "#555" }}
                                                                >
                                                                    {lineItemModifier.name} ($
                                                                    {lineItemModifier.price ? AmountDivideByHundred(lineItemModifier.price) : "0.00"} x
                                                                    {lineItemModifier.quantity})
                                                                </p>
                                                            ))}
                                                        </>
                                                    )}
                                                </div>
                                            ))}
                                        </>
                                    )}
                                </div>
                                <div style={{textAlign: "center", width: '10%'}}>
                                    <p style={{margin: "0"}}>{lineItem.quantity}</p>
                                </div>
                                <div style={{textAlign: "right", width: '30%'}}>
                                    <p style={{margin: "0"}}>${lineItem.totalPrice ? AmountDivideByHundred(lineItem.totalPrice) : "0.00"}</p>
                                </div>
                            </div>
                        );
                    })}
                    <div
                        className="d-flex align-items-center justify-content-between"
                        style={{ borderBottom: "2px dashed #B3B3B3", padding: "10px 0",}}
                    />
                </div>
                ) : ('');
            })}

            {/* Subtotal */}
            <div
                style={{
                    borderBottom: "2px dashed #B3B3B3",
                    marginBottom: "20px",
                    paddingBottom: "10px",
                }}
            >
                <h3  className="d-flex justify-content-between font-weight-bold">
                    <span>Sub Total</span> <span>${subtotal}</span>
                </h3>
                <div style={{ marginTop: "7.5px" }}>
                    <input
                        type="text"
                        className="input-box"
                        style={{ width: "calc(60% - 10px)" }}
                        placeholder="Enter Promo Code"
                        value={promoCodeValue}
                        onChange={(e) => setPromoCodeValue((e.target.value).toUpperCase())}
                    />
                    <Button
                        className="tip-button"
                        onClick={handleApplyPromo}
                    >
                        Apply
                    </Button>
                </div>
                {message ? (
                    <div style={{ margin: "5px" }}>
                        <span style={{ color: (message === 'Promo-Code applied' ? '#00B04A' : '#FF0000') }}>{message}</span>
                    </div>
                ) : (
                    <div style={{ margin: "5px" }} />
                )}
            </div>

            {/* Bill Details */}
            <div
                style={{
                    borderBottom: "2px dashed #B3B3B3",
                    marginBottom: "20px",
                    paddingBottom: "10px",
                }}
            >
                <h3 style={{ marginBottom: "20px", fontWeight: "bold"  }}>Bill details</h3>
                <p  className="d-flex justify-content-between" style={{  marginBottom: "10px" }}>
                    <span>Sub total</span> <span>${subtotal}</span>
                </p>
                {orderDiscount !== 0.00 && (
                    <p className="d-flex justify-content-between" style={{  marginBottom: "10px" }}>
                        <span>Discount</span> <span style={{ color: '#FF0000'}}>- ${orderDiscount}</span>
                    </p>
                )}
                {taxes !== 0.00 && (
                    <p className="d-flex justify-content-between" style={{  marginBottom: "10px" }}>
                        <span>Taxes</span> <span>${taxes}</span>
                    </p>
                )}
                {serviceCharge !== 0.00 && (
                    <p className="d-flex justify-content-between" style={{  marginBottom: "10px" }}>
                        <span>Service Charge ({serviceFeePercentage}%)</span> <span>${serviceCharge}</span>
                    </p>
                )}
                <p className="d-flex justify-content-between" style={{ marginBottom: "10px" }}>
                    <span>Tip</span> <span>${AmountDivideByHundred(tipAmount)}</span>
                </p>
                <div style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "left",
                    gap: "8px",
                    flexWrap: "wrap"
                }}>
                    <Button
                        className="tip-button"
                        onClick={() => {
                            setCustomTip(false);
                            setTip(0);
                            calculateOrder(0, 'AMOUNT', null, promoCode);
                        }}
                    >
                        None
                    </Button>

                    {eventDetails?.eventPageTips?.map((tips) => (
                        <Button
                            key={tips.tip}
                            className="tip-button"
                            onClick={() => {
                                setCustomTip(false);
                                setTip(Math.round(tips.tip * 100));
                                setTipType(tips.tipType);
                                calculateOrder(Math.round(tips.tip * 100), tips.tipType, null, promoCode);
                            }}
                        >
                            {tips.tipType === "AMOUNT" ? `$${tips.tip}` : `${tips.tip}%`}
                        </Button>
                    ))}

                    <Button
                        className="tip-button"
                        onClick={() => {
                            setCustomTip(true);
                            setTipAmount();
                            setTip();
                            calculateOrder(0, 'AMOUNT', null, promoCode)
                        }}
                    >
                        Custom
                    </Button>
                </div>
                {customTip && (
                    <div
                        className="d-flex justify-content-start align-items-center gap-8"
                        style={{
                            marginTop: "1%",
                            flexWrap: "wrap",
                        }}
                    >
                        <Input
                            className="input-box"
                            style={{ backgroundColor: "#FFFFFF", width: "30%", margin: 0 }}
                            value={tip}
                            prefix="$ "
                            placeholder="0.00"
                            onChange={(e) => {
                                const regex = /^\d*\.?\d*$/;
                                const { value } = e.currentTarget;
                                if (regex.test(value) || value === '') {
                                    setTip(e.currentTarget.value);
                                } else if (!regex.test(value)) {
                                    setTip(0.00);
                                }
                            }}
                            onKeyPress={e => {
                                const keyCode = e.charCode || e.which;
                                if ((keyCode < 48 || keyCode > 57) && keyCode !== 46 && keyCode !== 44) {
                                    e.preventDefault();
                                }
                            }}
                            onBlur={e => {
                                if (e.currentTarget.value) {
                                    const value = parseFloat(e.currentTarget.value).toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,');
                                    setTip(value);
                                }
                            }}
                        />
                        <Button
                            className="tip-button"
                            onClick={() => {
                                setTipType('AMOUNT');
                                calculateOrder(tip, 'AMOUNT', true, promoCode)
                            }}
                        >
                            Add
                        </Button>
                    </div>
                )}
            </div>

            {/* Total */}
            <h3
                className="d-flex justify-content-between font-weight-bold"
                style={{
                    marginBottom: "20px",
                    paddingBottom: "25px",
                    borderBottom: "2px solid #B3B3B3",
                }}
            >
                <span>Total</span> <span>${total}</span>
            </h3>

            {/* User Information */}
            { customInfoValues.length > 0 && (
                <div>
                    <h3 style={{marginBottom: "10px"}}>Your Information</h3>
                    {customInfoValues?.map((customInfo, index) => {
                        return (
                            <>
                                <input
                                    className="input-box"
                                    type={customInfo?.inputFieldType === 'INPUT_EMAIL' ? 'email' : 'text'}
                                    placeholder={customInfo?.inputFieldLabel}
                                    onChange={(e) => handleInputChange(index, e.target.value)}
                                    value={customInfo.value}
                                    style={{
                                        width: "100%",
                                        padding: "10px",
                                        marginRight: "0",
                                        marginTop: "5px",
                                        marginBottom: "5px",
                                    }}
                                />
                                <SpError fontSize="12px" color="#ff1e1e">
                                    {customInfo && !customInfo.isOptional && simpleValidator.current.message(customInfo?.inputFieldLabel, customInfo.value, 'required')}
                                </SpError>
                            </>
                        );
                    })}
                </div>
            )}

            {/* Footer */}
            <div style={{ textAlign: "center", marginTop: "20px", fontSize: "12px", color: "#888" }}>
                <img alt="" src={brand} style={{ height: '40px' }} />
            </div>
        </div>
    );
};

export default ProductReview;
